export function isCustomData(data) {
  return !!data.customContent;
}